import React, { useState } from "react";
import { useAlert } from "react-alert";

import linkImg1 from "../../../assets/images/contacto/Group 8518.png";
import linkImg2 from "../../../assets/images/contacto/Group 8519.png";
import linkImg3 from "../../../assets/images/contacto/Group 8520.png";
import { Country_Code, REGEX ,SERVER_URL,APP_ID} from "../../../constants/index";
import { ValidatePhone,AES_Encryption,GetDataFromServer,SetParameter, } from "../../../hooks";
import AlertModal from "../../atoms/AlertModal";
import Error_Img from "../../atoms/AlertModal"
import Success_Img from "../../../assets/images/pay_success.png";

import "./style.css";
import Loader from "../../atoms/Loader";


const Default_values = {
	nombre: "",
	apellido_materno: "",
	telefono: "",
	message:""
}
export default function ContactoPage() {
	const [errors, setErrors] = useState({});
	const alert = useAlert();

	const [isLoading, setLoading] = useState(false);
	const [registerDetail, setRegisterDetail] = useState({
		nombre: "",
		apellido_materno: "",
		telefono: "",
		message:""
	});

	const [modalAlert, setAlert] = useState({
		show: false,
		reason: null,
		img: null,
		heading: "",
		content: "",
		btn: "",
		subContent: "",
	});
	const Submit = () => {
		const url = SERVER_URL + "bts_ws_contact.aspx";
		const { nombre, apellido_materno, telefono,message } = registerDetail;

		if (
			nombre.length !== 0 &&
			apellido_materno.length !== 0 &&
			telefono.length !== 0
		) {
			let phoneValidate = telefono.match(REGEX["phone"]);

			if (
				REGEX["text"].test(nombre) &&
				REGEX["text"].test(apellido_materno) &&
				!REGEX["text"].test(telefono) &&
				telefono.length <= 10
			) {
				if (ValidatePhone(telefono, 10)) {
					setErrors({});
					let param = SetParameter({
						name:nombre,
						apellidos: apellido_materno,
						phone:telefono,
						message
					},APP_ID)
					setLoading(true);
					GetDataFromServer(url, AES_Encryption(param), (err, resp) => {
						if (err) {
							setLoading(false);
			
							setAlert({
								show: true,
								heading: "iUps, parece que hubo un error!",
								content:
									err?.data?.message ||
									"Por favor verifica que los dalos sean los correctos.",
								img: Error_Img,
								btn: "Aceptar",
							});
						}
						if (resp) {
							setLoading(false);
							setRegisterDetail(Default_values);
							setAlert({
								show: true,
								heading: "¡Gracias por tu confianza!",
								content: "Recibimos tu solicitud.",
								subContent:
									"En breve uno de los asesores y gurús de tranquilidad te contactará para hacerte llegar tu información.",
								img: Success_Img,
								btn: "Aceptar",
							});
						}
						console.log(param);
						console.log(err,resp)
					});
				} else {
					setErrors({ ...errors, ...{ telefono: true } });
					alert.show("Este campo sólo admite números");
				}
			} else {
				
				if (!REGEX["text"].test(nombre)) {
					setErrors({ ...errors, ...{ nombre: true } });
					return alert.show("Este campo sólo admite letras");
				}
				if (!REGEX["text"].test(apellido_materno)) {
					setErrors({ ...errors, ...{ apellido_materno: true } });
					return alert.show("Este campo sólo admite letras");
				}
				if (REGEX["text"].test(telefono)) {
					setErrors({ ...errors, ...{ telefono: true } });
					return alert.show("Este campo sólo admite números");
				}
				if (!phoneValidate || telefono.length > 10) {
					setErrors({ ...errors, ...{ telefono: true } });
					return alert.show(
						"el número de teléfono no está en el formato correcto",
					);
				}
			}
			return;
		}
		let ERR = {};
		if (nombre.length == 0) {
			ERR = { ...ERR, nombre: true };
		} else {
			let newErr = errors;
			delete newErr["nombre"];
			setErrors(newErr);
		}
		if (apellido_materno.length == 0) {
			ERR = { ...ERR, apellido_materno: true };
		} else {
			let newErr = errors;
			delete newErr["apellido_materno"];
			setErrors(newErr);
		}
		if (telefono.length == 0) {
			ERR = { ...ERR, telefono: true };
		} else {
			let newErr = errors;
			delete newErr["telefono"];
			setErrors(newErr);
		}

		setErrors({ ...errors, ...ERR });
		alert.show("Por favor complete todos los campos");
	};
	const handleInput = (e) => {
		const name = e.target.name;
		const value = e.target.value;

		setRegisterDetail({ ...registerDetail, [name]: value });
	};

	return (
		<div className='contacto_background'>
			<div className='contacto_header_comp'>
				<p className='contacto_header'>Contáctanos</p>
			</div>
			<div className='contacto_container'>
				<div className='contacto_form_comp'>
					<div className='contacto_form'>
						<div className='contacto_container'>
							<div className='contacto_form_body'>
								<p className='contacto_form_header'>
									Será un placer resolver tus dudas.
								</p>
								<div style={{ width: "100%" }}>
									<input
										className='form-control'
										placeholder='Nombre(s)'
										value={registerDetail?.nombre}
										onChange={handleInput}
										name='nombre'
										style={
											errors?.nombre
												? { borderColor: "red", width: "100%" }
												: { width: "100%" }
										}
									/>
									<input
										className='form-control'
										placeholder='Apellido(s)'
										name='apellido_materno'
										onChange={handleInput}
										value={registerDetail?.apellido_materno}
										style={
											errors?.apellido_materno
												? {
														borderColor: "red",
														width: "100%",
														marginTop: "20px",
												  }
												: { width: "100%", marginTop: "20px" }
										}
									/>
									<div className='row'>
										
										<div className='col-sm-12'>
											<input
												className='form-control'
												placeholder='Teléfono'
												name='telefono'
												maxLength={10}
												onChange={handleInput}
												value={registerDetail?.telefono}
												style={
													errors?.telefono
														? {
																borderColor: "red",
																width: "100%",
																marginTop: "20px",
														  }
														: { width: "100%", marginTop: "20px" }
												}
											/>
										</div>
									</div>
									<textarea
										rows={8}
										className='form-control'
										name="message"
										value={registerDetail.message}
										placeholder='Mensaje'
										style={{ width: "100%", marginTop: "20px" }}
										onChange={handleInput}
									/>
									<button
										onClick={Submit}
										style={{
											color: "white",
											marginTop: "40px",
											borderRadius: "15px",
											width: "208px",
											height: "43px",
											backgroundColor: "#F89900",
											border: "3px solid white",
											boxShadow: "2px 2px 10px 2px rgb(0,0,0,0.6)",
										}}>
										Enviar
									</button>
									<p
										style={{
											textAlign: "center",
											color: "white",
											marginTop: "20px",
										}}>
										Comunícate con nosotros
									</p>
									<div
										style={{
											display: "flex",
											flexDirection: "row",
											justifyContent: "center",
											marginTop: "20px",
										}}>
										<div style={{ flexDirection: "column", margin: "20px" }}>
											<a href='http://m.me/Bajatuseguro' target='_blank'>
												<img src={linkImg1} />{" "}
											</a>
										</div>
										<div style={{ flexDirection: "column", margin: "20px" }}>
											<a href='tel:8004392252'>
												<img src={linkImg3} />
											</a>
										</div>
										<div style={{ flexDirection: "column", margin: "20px" }}>
											<a href='https://wa.me/8004392252' target='_blank'>
												<img src={linkImg2} />{" "}
											</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className='contacto_comp'>{/* image part */}</div>
			</div>
			{/* Modal Alert to show success or error messages */}
			{modalAlert.show && (
				<AlertModal
					heading={modalAlert.heading}
					content={modalAlert.content}
					subContent={modalAlert.subContent}
					img={modalAlert.img}
					btn={modalAlert.btn}
					modalShow={modalAlert.show}
					setModalShow={() => setAlert({ ...modalAlert, show: false })}
				/>
			)}

			{isLoading && <Loader />}
		</div>

	);

}
